import apiHelper from '@/services/helper'

const getOverviewCustomerProfile = async (param) => {
    try {
        let url = '/admin/overview/customer-profile'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getOverviewBillingProfile = async (param) => {
    try {
        let url = '/admin/overview/billing-profile'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getOverviewSubscriptionProfile = async (param) => {
    try {
        let url = '/admin/overview/subscription-profile'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getOverviewTransactionProfile = async (param) => {
    try {
        let url = '/admin/overview/transaction-profile'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

export default {
    getOverviewCustomerProfile,
    getOverviewBillingProfile,
    getOverviewSubscriptionProfile,
    getOverviewTransactionProfile
}
